<ziro-select
  fieldId="extensionSearch"
  (selectBlur)="handleOnBlur()"
  (selectWasCleared)="handleSelectClear()"
  (searchHasChanged)="handleInputChange($event)"
>
  @if (!isSingleButton() || phoneType === phoneTypes.DESKPHONE) {
    <div style="min-height: 1.5em">
      @if (!hideHelpText && formData.extensionSearch) {
        <small class="text-muted clickable-cursor" data-automation="dnd-line-extension-search-modal-button">
          <i [ngClass]="ziroIcons.EDIT" class="me-1 text-primary"></i>
          <span data-automation="edit-extension-link" class="text-primary" (click)="openDetailedModal()">
            {{
              'tkey;shared.device.phone.phone_buttons.line_button.line_extension.search.helptext.existing.text'
                | translate
            }}
            - {{ dnRef().description }} {{ dnRef().extension }}
          </span>
        </small>
      }
      @if (!hideHelpText && !formData.extensionSearch) {
        <small class="text-muted">
          {{ 'tkey;shared.device.phone.phone_buttons.line_button.line_extension.search.helptext.new.text' | translate }}
          <span
            class="text-primary clickable-cursor"
            (click)="openDetailedModal()"
            data-automation="add-extension-link"
          >
            {{
              'tkey;shared.device.phone.phone_buttons.line_button.line_extension.search.helptext.new.link' | translate
            }}
          </span>
        </small>
      }
    </div>
  }
</ziro-select>
<ziro-text [fieldId]="'voicemail'"></ziro-text>
@if (dnRef() && unityServerId) {
  <div class="row mb-3">
    <div class="col-3 d-flex align-items-center justify-content-end">
      <label class="m-0">
        {{
          'tkey;shared.device.phone.phone_buttons.line_button.line_extension.search.voicemail_alias.label' | translate
        }}
      </label>
    </div>
    <div class="col-9" [ngClass]="{ 'text-start': isSingleButton() }">
      <button
        (click)="
          isEndUserPrimary() && isOneClickEnabled && !voicemailRef
            ? addVoicemailOneClick()
            : voicemailRef
              ? openAddOrEditVmDetailedModal(voicemailRef)
              : openAddOrEditVmDetailedModal()
        "
        class="btn-border"
        [ngClass]="
          (isVoicemailAdding || isUpdatingSmtpOrHomeCluster) && !voicemailRef ? 'btn btn-warning' : 'btn btn-default'
        "
        data-automation="dnd-line-extension-voicemail-add-button"
        [disabled]="isVoicemailAdding || isSubmitting"
      >
        @if (!isVoicemailAdding && !voicemailRef) {
          <i [ngClass]="ziroIcons.ADD"></i>
        }
        @if ((isVoicemailAdding || isUpdatingSmtpOrHomeCluster) && !voicemailRef) {
          <i [ngClass]="ziroIcons.SAVING"></i>
        }
        @if (!isUpdatingSmtpOrHomeCluster && !voicemailRef) {
          <span [ngClass]="{ 'ms-1': isVoicemailAdding }" data-automation="dnd-line-extension-voicemail-add-text">
            {{
              isVoicemailAdding
                ? ('tkey;shared.device.phone.phone_buttons.line_button.line_extension.search.voicemail_adding.text'
                  | translate)
                : ('tkey;shared.device.phone.phone_buttons.line_button.line_extension.search.voicemail_add.text'
                  | translate)
            }}
          </span>
        }
        @if (voicemailRef) {
          <i [ngClass]="ziroIcons.VOICEMAIL_SMALL"></i>
        }
        @if (voicemailRef) {
          <span class="ms-1" data-automation="dnd-line-extension-voicemail-alias">
            {{ voicemailRef.alias }}
          </span>
        }
      </button>
    </div>
  </div>
}
